module.exports = __webpack_public_path__ + "static/img/banner_solutions_system.b8be4fe.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobile/resource/images/solution/banner_solutions_system.png
// module id = 0lc+
// module chunks = 10